module.exports = __webpack_public_path__ + "static/media/TUNE_6452.4e6d3116.jpg";